import { node } from "~/util/dom";

interface IReportHubButtonOptions extends Partial<HTMLButtonElement> {
	className: string;
}

export function createReportHubButton({
	className = "",
	...rest
}: Partial<IReportHubButtonOptions> = {}): HTMLButtonElement {
	const button = node("button", {
		className: `ui-report-hub-button ${className}`,
		...rest,
	});

	return button;
}
